import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { DASHBOARD_RANGES, getRangeLabel } from './optionsDashboardUtils';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';

export const OptionsDashboardRangeControls = ({
  selectedRange,
  onRangeChange,
  customRange,
  onCustomRangeChange,
  onApplyCustomRange,
  isFetching = false,
}) => {
  const { t } = useOptionsLocale();

  return (
    <div className="space-y-3 rounded-[24px] border border-white/10 bg-black/20 px-4 py-4" data-testid="options-dashboard-trading-range-controls">
      <div className="flex items-center gap-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40" data-typography="label" data-testid="options-dashboard-trading-range-label">
          {t('common.period')}
        </p>
        {isFetching ? (
          <RefreshCw size={12} className="animate-spin text-white/40" data-testid="options-dashboard-trading-range-fetching-indicator" />
        ) : null}
      </div>

      <div className="inline-flex w-full flex-wrap items-center gap-1.5 rounded-[18px] border border-white/10 bg-[#11161E] p-1.5 shadow-[inset_0_1px_0_rgba(255,255,255,0.03)]" data-testid="options-dashboard-trading-range-tabs">
        {DASHBOARD_RANGES.map((range) => {
          const isActive = selectedRange === range;
          return (
            <button
              key={range}
              type="button"
              onClick={() => onRangeChange(range)}
              data-testid={`options-dashboard-trading-range-${range}`}
              className={`inline-flex items-center rounded-[14px] px-3 py-2 text-sm font-semibold transition-all duration-200 font-body ${isActive ? 'bg-[#202A38] text-white shadow-[inset_0_0_0_1px_rgba(255,255,255,0.08)]' : 'text-white/62 hover:bg-white/[0.04] hover:text-white'}`}
              data-typography="nav"
            >
              {getRangeLabel(range, t)}
            </button>
          );
        })}
      </div>

      {selectedRange === 'custom' ? (
        <div className="flex flex-wrap items-center gap-3" data-testid="options-dashboard-trading-custom-range-controls">
          <input
            type="date"
            value={customRange.startDate}
            onChange={(event) => onCustomRangeChange((current) => ({ ...current, startDate: event.target.value }))}
            className="rounded-xl border border-white/10 bg-white/[0.03] px-3 py-2 text-sm text-white outline-none"
            data-testid="options-dashboard-trading-custom-range-start"
          />
          <input
            type="date"
            value={customRange.endDate}
            onChange={(event) => onCustomRangeChange((current) => ({ ...current, endDate: event.target.value }))}
            className="rounded-xl border border-white/10 bg-white/[0.03] px-3 py-2 text-sm text-white outline-none"
            data-testid="options-dashboard-trading-custom-range-end"
          />
          <Button variant="outline" onClick={onApplyCustomRange} data-testid="options-dashboard-trading-custom-range-apply">
            {t('common.apply')}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default OptionsDashboardRangeControls;